'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var magicCommon = require('@gig/magic-common');
var magicFormBuilder = require('@gig/magic-form-builder');

function gender() {
    return {
        id: 'gender-wrapper',
        component: 'magic-ui-form-field',
        isDataField: false,
        properties: {
            class: 'form-field form-field--sex',
        },
        validation: [
            {
                name: 'required',
                fn: magicFormBuilder.required,
                message: '',
            },
        ],
        children: [
            {
                id: 'sex',
                component: 'magic-ui-radio-group',
                properties: {
                    value: 'M',
                    inline: true,
                },
                isDataField: true,
                testId: 'step2-genders',
                children: [
                    {
                        id: 'male',
                        component: 'magic-ui-radio',
                        setValueTo: 'sex',
                        isDataField: false,
                        testId: 'step2-male',
                        v: {
                            html: magicCommon.translate('sign-up-step-two.male'),
                        },
                        properties: {
                            value: 'M',
                            class: 'field field--sex',
                        },
                    },
                    {
                        id: 'female',
                        component: 'magic-ui-radio',
                        setValueTo: 'sex',
                        isDataField: false,
                        testId: 'step2-female',
                        v: {
                            html: magicCommon.translate('sign-up-step-two.female'),
                        },
                        properties: {
                            value: 'F',
                            class: 'field field--sex',
                        },
                    },
                ],
                converter: function (formValue) {
                    return {
                        gender: formValue.sex.value,
                    };
                },
            },
        ],
    };
}

exports.gender = gender;
